import { Component, Input, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import {
  FitnessPlanDay,
  PlanDayProcessing,
} from 'app/@core/interfaces/common/CalorieFriend/plan-day';

import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';

/**
 * Component for Fitness Summary.
 */
@Component({
  selector: 'app-fitness-summary',
  templateUrl: './fitness-summary.component.html',
  styleUrls: ['./fitness-summary.component.scss'],
})
export class FitnessSummaryComponent extends BaseComponentCanDeactivate {
  SummaryLabel = $localize`:@@Summary:Summary`;
  ExercisesLabel = $localize`:@@Exercises:Exercises`;
  RepsLabel = $localize`:@@Reps:Reps`;
  MinutesLabel = $localize`:@@Minutes:Minutes`;
  CalorieBurnedLabel = $localize`:@@CalorieBurned:Cals Burned`;

  Exercises = 0;
  Reps = 0;
  Minutes = 0;
  CalorieBurned = 0;

  data: any;
  options: any;
  themeSubscription: any;

  SummaryWidth = '80px';
  @Input('SummaryWidth') set UpdateSummaryWidth(Width: string) {
    this.SummaryWidth = Width;
  }

  SummaryHeight = '80px';
  @Input('SummaryHeight') set UpdateSummaryHeight(Height: string) {
    this.SummaryHeight = Height;
  }

  /**
   * Input to specify Exercises.
   */
  @Input('Exercises') set UpdateExercises(exercises: number) {
    this.Exercises = exercises;
  }

  /**
   * Input to specify Reps.
   */
  @Input('Reps') set UpdateReps(reps: number) {
    this.Reps = reps;
  }

  /**
   * Input to specify Minutes.
   */
  @Input('Minutes') set UpdateMinutes(minutes: number) {
    this.Minutes = minutes;
  }

  /**
   * Input to specify CalorieBurned.
   */
  @Input('CalorieBurned') set UpdateFats(calorieBurned: number) {
    this.CalorieBurned = calorieBurned;
  }

  /** MealMetricsGraph ctor */
  constructor(dialogService: NbDialogService) {
    super(dialogService);
  }
}

/**
 * Component for Day Fitness Summary.
 * Inherits from FitnessSummaryComponent component.
 */
@Component({
  selector: 'app-day-fitness-summary',
  templateUrl: './fitness-summary.component.html',
  styleUrls: ['./fitness-summary.component.scss'],
})
export class DayFitnessSummaryComponent
  extends FitnessSummaryComponent
  implements OnInit {
  CurrentSelection = '';
  ApplyAllDaysLabel = 'Apply To All Days';
  ApplyAllDays: boolean = false;
  @Input('PlanDays') PlanDays: Array<FitnessPlanDay> = null;
  @Input('ActiveDay') Day: FitnessPlanDay = null;
  @Input('ViewOnly') ViewOnly: boolean = false;

  Processing: Array<PlanDayProcessing> = null;

  constructor(AGCDialogService: NbDialogService) {
    super(AGCDialogService);
  }

  ngOnInit(): void {
    this.Processing = new Array<PlanDayProcessing>();
    this.PrepareBlockItems();
  }

  /**
   * Function to update the processing list of Plan days.
   */
  PrepareBlockItems() {
    if (this.PlanDays != null && this.PlanDays !== undefined) {
      for (const day of this.PlanDays) {
        const found = this.Processing.find(
          (addedday) => addedday.Day.id === day.id,
        );
        if (found == null || found === undefined) {
          // to-do: found = new PlanDayProcessing(day, this.foodService);
          // to-do: this.Processing.push(found);
        }
        // to-do: found.UpdateProcessing();
      }
    }
  }

  CheckedChange($event) {
    this.ApplyAllDays = $event;
  }
}
